import "./base.js";

class ManipulateRadio extends BaseManipulateInput {
  constructor(input) {
    super(input);
  }

  getValue() {
    return this.input.is(":checked") ? this._booleanStringsToBoolean(this.input.val()) : null;
  }

  setValue(value) {
    this.input.each((i, element) => {
      jQuery(element).prop("checked", jQuery(element).val() == `${value}`);
    });
  }

  // PRIVATE

  _booleanStringsToBoolean(value) {
    if (value === "true") {
      return true;
    } else if (value === "false") {
      return false;
    } else {
      return value;
    }
  }
}

window.ManipulateRadio = ManipulateRadio;
